"use strict";

var Constants = require("../designer/Constants");
var WizardConstants = require("../constants/WizardConstants");

var deviceTypes = Constants.DEVICE_TYPES;
var deviceMinWidths = Constants.DEVICE_MIN_WIDTHS;

var CardConnectHelper = {
	initializeCardConnect: function($parent) {
		this._initializeListeners($parent);
		this._manageIframeAttributes(null, $parent);
	},

	_initializeListeners: function($parent) {
		$parent = $parent || $("body");

		$parent.find("[data-component='cardConnectCardNumber']").each((index, element) => {
			var $element = $(element);
			$element.attr("data-has-custom-validator", true).data({customValidator: this.validateCardNumberToken.bind(this, $element)});
		});

		//CardConnect fires this event in order for us to capture the card number token.
		window.addEventListener("message", this._setCardConnectToken);

		window.addEventListener("resize", this._manageIframeAttributes);
	},

	//selector can be a jQuery object or jQuery selector
	isCardConnect: function(selector) {
		var $selector = $(selector || "body");
		return Boolean(
			$selector.closest("[data-component='cardConnectCreditCardPayment']").length ||
			$selector.find("[data-component='cardConnectCreditCardPayment']").length
		);
	},

	getCardConnectToken: function($element) {
		if (this.isCardConnect($element)) {
			var token = $element.attr("data-cardconnect-token");
			return token;
		}

		return null;
	},

	_manageIframeAttributes: function(event, $parent) {
		$parent = $parent || $("body");

		if (window.AccountStore.get("isDesignMode")) {
			return;
		}

		var getDeviceType = function() {
			var device = deviceTypes.DESKTOP;

			var width = window.innerWidth;

			if (width < deviceMinWidths.TABLET) {
				device = deviceTypes.MOBILE;
			} else if (width < deviceMinWidths.DESKTOP) {
				device = deviceTypes.TABLET;
			}

			return device;
		};

		var setIframeAttributes = function($iframe, device) {
			var style = $iframe.attr(`data-${device}-style`);
			if (style) {
				$iframe.attr("style", style);
			}

			var src = $iframe.attr(`data-src`);
			var srcCss = $iframe.attr(`data-${device}-css`);
			if (src && srcCss) {
				$iframe.attr("src", `${src}${srcCss}`);
			}

			$iframe.attr("data-set-device", device);
		};

		var device = getDeviceType();

		var $iframes = $parent.find("[data-component='cardConnectCardNumber']");
		$iframes.each((index, iframe) => {
			var $iframe = $(iframe);

			if (device !== $iframe.attr("data-set-device")) {
				setIframeAttributes($iframe, device);
			}
		});
	},

	_setCardConnectToken: function(event) {
		// it is possible for this method to be called by other origins
		if (!event.origin.includes("cardconnect")) {
			return;
		}

		var data = JSON.parse(event.data);
		var keys = Object.keys(data);
		var id = keys.find((element) => {
			return element.startsWith("DDCCC");
		});
		var token = data[id];

		var $currentIframe = $(`#${id}`);

		if ($currentIframe) {
			if (token) {
				$currentIframe.attr("data-cardconnect-token", token);
			} else {
				$currentIframe.removeAttr("data-cardconnect-token");
			}
		}
	},

	validateCardNumberToken: function($element) {
		var errorMessages = [];

		var token = this.getCardConnectToken($element);
		if (!token) {
			var cardNumberTokenMessage = this._getStore().getWizardValue(
				WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES,
				WizardConstants.CARDCONNECT_MESSAGE_FIELDS.CARD_NUMBER_TOKEN
			);

			errorMessages.push(cardNumberTokenMessage);
		}

		return { isValid : !errorMessages.length, errorMessages : errorMessages };
	},

	_getStore: function() {
		if (window.CheckoutStore) {
			return window.CheckoutStore;
		}

		return window.AccountStore;
	}
};

module.exports = CardConnectHelper;



// WEBPACK FOOTER //
// ./Javascript/commonComponents/CardConnectHelper.jsx